import { render, staticRenderFns } from "./alert-response.vue?vue&type=template&id=7f0fc5c4&scoped=true"
import script from "./alert-response.ts?vue&type=script&lang=ts&external"
export * from "./alert-response.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0fc5c4",
  null
  
)

export default component.exports